import { useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const API = `${API_BASE}/api`;

export default function AutoGenerate() {

    const { paperId, softwareId } = useParams();
    const navigate = useNavigate();

    const [blueprints, setBlueprints] = useState([]);
    const [loading, setLoading] = useState(false);
    const [confirmId, setConfirmId] = useState(null);

    const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("accessToken")}`
    };

    useEffect(() => {
        loadBlueprints();
    }, []);

    const loadBlueprints = async () => {
        const res = await axios.get(
            `${API}/Blueprints?softwareId=${softwareId}`,
            { headers }
        );
        setBlueprints(res.data);
    };

    /* ---------- GENERATE ---------- */

    const generatePaper = async () => {
        setLoading(true);

        await axios.post(
            `${API}/Papers/${paperId}/auto-generate?blueprintId=${confirmId}`,
            {},
            { headers }
        );

        alert("Paper Generated Successfully");

        navigate("/dashboard/exammanagment");
    };

    return (
        <div className="create-exam-wrapper">

            <h2>Select Blueprint</h2>

            <div className="table-card">
                <table>
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Name</th>
                            <th>Paper</th>
                            <th>Status</th>
                            <th>Rules</th>
                            <th>Action</th>
                        </tr>
                    </thead>

                    <tbody>
                        {blueprints.map(b => (
                            <tr key={b.id}>
                                <td>{b.id}</td>
                                <td>{b.name}</td>
                                <td>{b.paperNumber || "-"}</td>
                                <td>{b.isActive ? "Active" : "Inactive"}</td>

                                <td>
                                    {b.rules?.map(r => (
                                        <div key={r.id}>
                                            {r.subjectName} — {r.topic}
                                        </div>
                                    ))}
                                </td>

                                <td>
                                    <button
                                        className="exam-popup-btn primary"
                                        onClick={() => setConfirmId(b.id)}
                                    >
                                        Generate
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            {/* CONFIRM POPUP */}
            {confirmId && (
                <div className="exam-popup-overlay">
                    <div className="exam-popup-card">

                        <h3>Confirm Generation</h3>
                        <p>Are you sure you want to generate paper using this blueprint?</p>

                        <div className="exam-popup-actions">

                            <button
                                className="exam-popup-btn outline"
                                onClick={() => setConfirmId(null)}
                            >
                                Cancel
                            </button>

                            <button
                                className="exam-popup-btn primary"
                                disabled={loading}
                                onClick={generatePaper}
                            >
                                {loading ? "Generating..." : "Confirm"}
                            </button>

                        </div>

                    </div>
                </div>
            )}

        </div>
    );
}
